import React,{useEffect, useState} from "react";
import { $ } from "react-jquery-plugin";
import ForgotPassword from "./components/login/forgotForm";
import Login from './components/login/LoginComponent'
import { Routes, Route, } from "react-router-dom";  
import ListRegisterEvent from "./components/events/register/ListRegisterEvent";
import AdminLogin from "./components/login/AdminLogin";
import PublicRegistering from "./components/events/register/PublicRegistration";
import AssociationLogin from "./components/login/AssociationLogin";
import App from "./App";
import PublicRegisteringSeminar from "./components/events/register/PublicRegistrationSeminar";
import OfficialPaymentPDF from "./components/associations/official/officialPaymentPDF";
import PayFormUI from "./components/registerFormOfficials.js/PayFormUI";
import CheckPaymentPDF from "./components/events/CheckPaymentPDF";
import AssociationAccordian from "./components/associations/associationAccordian";

import PublicRegistrationExhibition from "./components/exhibitions/register/PublicRegistrationExhibition";
import ExhibitionPaymentPDF from './components/exhibitions/exhibitionPdfCheck';
import ExhibitionPaymentForm from "./components/exhibitions/paymentForm";
import RegisterFormCoach from "./components/registerFormOfficials.js/registerFormCoach";
import RuleList from "./components/registerFormOfficials.js/rulesList";
import SelectRule from "./components/registerFormOfficials.js/selectRule";
import CoachLogin from "./components/login/CoachLogin";
import ListofSchool from "./components/schools/listofSchool"
import SchooldirectoryPdf from "./components/schools/schooldirectorypdf"
import EditCoaches from "./components/registerFormOfficials.js/editcoaches";



const Auth = () =>{

  const [token, setToken] = useState('')

  useEffect(()=>{
    let storevariable = localStorage.getItem('token');
    setToken(storevariable)
  })
  
  
  

    return( 
      <div>

            <Routes> 
                <Route exact path="/" element={ <Login/> } />   
                <Route path="/admin" exact element={ <AdminLogin/> } />
                <Route path="/coaches" exact element={ <CoachLogin/> } />   
                <Route path="/associations/login" exact element={ <AssociationLogin/> } />   
                <Route path="/register_event/" exact element={ <ListRegisterEvent/>} />
                <Route path="/forgot_password" exact element={ <ForgotPassword/> } />
                <Route path="/public_registration/conference" exact element={ <PublicRegistering/>} />
                <Route path="/public_registration/seminar" exact element={ <PublicRegisteringSeminar/>} />
                <Route path='/checkpayment/:sname/:assname/:count' exact element={<OfficialPaymentPDF />} /> 
                <Route path="*" exact element={ <App/>} />
                <Route path="/payment/:rid/" exact element={ <PayFormUI/> } />
                <Route path="/check_payment_form/" exact element={ <CheckPaymentPDF /> } />
                <Route path="/sports_association/" exact element={ <AssociationAccordian /> } />

                <Route path="/public_registration/exhibition" exact element={ <PublicRegistrationExhibition/>} />
                <Route path="/exhibition_check/" exact element={ <ExhibitionPaymentPDF /> } />
                <Route path="/exhibition_payment" exact element={ <ExhibitionPaymentForm/> } />
                <Route path="/registrationcoaches" exact element={ <RegisterFormCoach/> } />
                <Route path="/listofschool" exact element={ <ListofSchool/> } />
                <Route path="/schooldirectory" exact element={ <SchooldirectoryPdf/> } />
                <Route path="/rules_list/" exact element={ <RuleList/>} />
                <Route path="/select_rule/" exact element={ <SelectRule/>} />
                <Route path="/editcoaches/:id" exact element={ <EditCoaches/>} />
            </Routes>
            

      </div>
    )
};

export default Auth;
